// extracted by mini-css-extract-plugin
export var actions = "_14-0";
export var actionsContainer = "_14-7";
export var border = "_14-1";
export var childFullHeight = "_14-f";
export var collapse = "_14-2";
export var content = "_14-a";
export var contentChild = "_14-e";
export var fullscreen = "_14-c";
export var hasLeftRadius = "_14-k";
export var headerContainer = "_14-3";
export var headerRow = "_14-5";
export var hidePadding = "_14-b";
export var navCollapsedGap = "_14-l";
export var noScrollX = "_14-m";
export var noScrollY = "_14-n";
export var noTopPadding = "_14-i";
export var optOutTopPadding = "_14-d";
export var pageMain = "_14-j";
export var pageOuter = "_14-g";
export var pagePadding = "_14-8";
export var pageScroll = "_14-9";
export var profile = "_14-o";
export var profileContainer = "_14-p";
export var profileImage = "_14-q";
export var profileMain = "_14-r";
export var profileSubtitle = "_14-t";
export var profileTitle = "_14-s";
export var showLeftPadding = "_14-h";
export var tabsPortalSlot = "_14-6";
export var tabsWrapper = "_14-4";
export var title = "_14-u";